export default "__VITE_ASSET__C8A05T4L__"